import { createUseStyles } from 'react-jss';
import { Trans, useTranslation } from 'react-i18next';

import { SubmitButton, TooltipText } from '@app/core';
import { Theme } from '@app/theme';
import { SignupParticipantForm } from '@app/auth';

import { Participant, Session, StudyType } from '@app/api';
import { FakerPersonalButton } from '../faker';
import { requirePropFactory } from '@mui/material';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h5,
    margin: `${theme.marginBase * 3}px 0`,
    whiteSpace: 'pre-line',
  },
  dataInfo: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
  container: {
    maxWidth: theme.maxContentWidth.reduced,
    margin: 'auto',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.marginBase,
  },
}));

interface Props {
  onSuccess?: (participant: Participant) => any;
  session: Session;
  participantId?: string;
  requirePhoneNumber?: boolean;
  countryKey?: string;
}

export const ParticipantInformations = ({
  onSuccess,
  session,
  participantId,
  requirePhoneNumber,
  countryKey,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>
        <Trans i18nKey="participantForm.title" />
      </h2>
      <TooltipText title={t('participantForm.dataInfo.tooltip')}>
        <div className={classes.dataInfo}>
          <Trans i18nKey="participantForm.dataInfo.text" />
        </div>
      </TooltipText>
      <SignupParticipantForm
        onSuccess={onSuccess}
        sessionId={session.id}
        askForPhone={requirePhoneNumber}
        participantId={participantId}
        trackingContext="session"
        countryKey={countryKey}
      >
        <div className={classes.buttonContainer}>
          <FakerPersonalButton />
          <SubmitButton fullMobileWidth trackingName="Signup Confirmation">
            <Trans i18nKey="participantForm.send" />
          </SubmitButton>
        </div>
      </SignupParticipantForm>
    </div>
  );
};
